// extracted by mini-css-extract-plugin
export default {"itemPlaceholder":"Dropdown_itemPlaceholder__NqXTL","selectWrapper":"Dropdown_selectWrapper__qFD1B","placeholder":"Dropdown_placeholder__bL7Av"};